
















































































import Vue from 'vue';
import Component from 'vue-class-component';

// Store types
import { SpacesGetter } from '@/store/store.types';

// Steps and steps types
import Steps from '@/steps/steps';
import { Step, Steps as ISteps, StepBack, StepConfig } from '@/steps/types';

/**
 *  Component that indicates the current step,
 *  and the progress of the order process.
 */
@Component
export default class ProgressBar extends Vue {

    /**
     *  Forward the steps to paint.
     */
    private steps: ISteps = Steps;

    /**
     *  Used to get the fact if the progess should
     *  be hidden for the current step.
     */
    private get hidden(): boolean | null {

        return this.$route.meta ? this.$route.meta.hideProgress ?? null : null;

    }

    /**
     *  Used to get the current's route back button meta,
     *  used to paint a back button accordingly.
     */
    private get back(): StepBack | null {

        return this.$route.meta ? this.$route.meta.back ?? null : null;

    }

    /**
     *
     *  Used to determine if the forwarded step should be disabled.
     *
     *  @param step The step to check its disabled state for
     *
     *  (i) Forcing the user to always navigate through the products to motivate upsells
     *
     *  @returns If the step is disabled
     *
     */
    private isDisabled(step: StepConfig): boolean {

        switch (step.name) {

            case Step.Products:

                if (!this.$store.getters[SpacesGetter.COUNT_ADDED]) {

                    return true;

                }

                return !this.$store.getters[SpacesGetter.COUNT_VALID];

            default:

                return step.index > this.$store.state.steps.current.index;

        }

    }

    /**
     *
     *  Used to navigate to the forwarded route.
     *
     *  @param step The step (config) to navigate to
     *
     *  (i) Prevents navigation to a disabled or already active step
     *
     */
    private navigate(step: StepConfig): void {

        if (this.isDisabled(step) || this.$route.name === step.name) {

            return;

        }

        void this.$router.push(step.name);

    }

    /**
     *
     *  Used to navigate back.
     *
     *  (i) Only the name of the step is saved for the back button
     *
     *  @param step The step (name) to navigate to
     *
     */
    private navigateBack(step: Step): void {

        this.navigate(Steps[step]);

    }

}
